import {timeParse} from 'd3'

export const timeParser = timeParse('%Y-%m-%d %H:%M:%S')
